import { PERMISSIONS } from "@/core/enums/permissions.enum";
import { ReactNode } from "react";

export interface MenuItem {
  label: string,
  icon?: ReactNode,
  key: string,
  children?: MenuItem[],
  permissions?: {
    view?: string,
    add?: string,
    edit?: string,
    delete?: string
  }
};

const ICON_WIDTH = 22;

export const HOME_NAV_ITEMS: MenuItem[] = [
  {
    label: 'Tổng quan',
    icon: <img className="mr-4 menu-icon" alt='' width={ICON_WIDTH} height={ICON_WIDTH} src='/images/layout/sidebar/chart-column-solid.svg' />,
    key: '',
  },
  {
    label: 'Quản lý Khách hàng',
    icon: <img className="mr-4 menu-icon" alt='' width={ICON_WIDTH} height={ICON_WIDTH} src='/images/layout/sidebar/people-group-solid.svg' />,
    key: 'customer',
    children: [
      {
        label: 'Danh sách Khách hàng',
        key: 'contracts',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.WATERUSER_VIEW.key,
          add: PERMISSIONS.WATERUSER_ADD.key,
          edit: PERMISSIONS.WATERUSER_EDIT.key,
          delete: PERMISSIONS.WATERUSER_DELETE.key
        }
      },
      {
        label: 'Đơn đăng ký cấp nước',
        key: 'water-registration',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.USEWATER_VIEW.key,
          add: PERMISSIONS.USEWATER_ADD.key,
          edit: PERMISSIONS.USEWATER_EDIT.key,
          delete: PERMISSIONS.USEWATER_DELETE.key
        }
      },
      {
        label: 'Xuất báo cáo QLKH',
        key: 'customer-report',
        icon: <div><div className="dot-icon"></div></div>,
      },
      {
        label: 'Hợp đồng điện tử',
        key: 'electronic-contract',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.ELECTRONICCONTRACT_VIEW.key,
          add: PERMISSIONS.ELECTRONICCONTRACT_ADD.key,
          edit: PERMISSIONS.ELECTRONICCONTRACT_EDIT.key,
          delete: PERMISSIONS.ELECTRONICCONTRACT_DELETE.key
        }
      }
    ]
  },
  {
    label: 'Ghi chỉ số',
    icon: <img className="mr-4 menu-icon" alt='' width={ICON_WIDTH} height={ICON_WIDTH} src='/images/layout/sidebar/meter-droplet.svg' />,
    key: 'meter-reading',
    children: [
      {
        label: 'Sổ đọc nước',
        key: 'water-index',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.WATERINDEX_VIEW.key,
          add: PERMISSIONS.WATERINDEX_ADD.key,
          edit: PERMISSIONS.WATERINDEX_EDIT.key,
          delete: PERMISSIONS.WATERINDEX_DELETE.key
        }
      },
      // {
      //   label: 'Đồng hồ nước',
      //   key: 'water-meter',
      //   icon: <div><div className="dot-icon"></div></div>,
      // },
      {
        label: 'Lịch đọc số nước',
        key: 'read-meter-period',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.READMETER_VIEW.key,
          add: PERMISSIONS.READMETER_ADD.key,
          edit: PERMISSIONS.READMETER_EDIT.key,
          delete: PERMISSIONS.READMETER_DELETE.key
        }
      },
      {
        label: 'Xuất báo cáo Chỉ số nước',
        key: 'index-report',
        icon: <div><div className="dot-icon"></div></div>
      }
    ]
  },
  {
    label: 'Thu tiền nước và hoá đơn',
    icon: <img className="mr-4 menu-icon" alt='' width={ICON_WIDTH} height={ICON_WIDTH} src='/images/layout/sidebar/circle-dollar-to-slot.svg' />,
    key: 'billing',
    children: [
      {
        label: 'Bảng tính phí',
        key: 'billing-table',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.WATERINVOICE_VIEW.key,
          add: PERMISSIONS.WATERINVOICE_ADD.key,
          edit: PERMISSIONS.WATERINVOICE_EDIT.key,
          delete: PERMISSIONS.WATERINVOICE_DELETE.key
        }
      },
      {
        label: 'Phiếu thu tiền',
        key: 'topup-transaction',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.TOPUPTRANSACTION_VIEW.key,
          add: PERMISSIONS.TOPUPTRANSACTION_ADD.key,
          edit: PERMISSIONS.TOPUPTRANSACTION_EDIT.key,
          delete: PERMISSIONS.TOPUPTRANSACTION_DELETE.key
        }
      },
      {
        label: 'Lịch sử giao dịch',
        key: 'transaction-history',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.TRANSACTION_VIEW.key,
          add: PERMISSIONS.TRANSACTION_ADD.key,
          edit: PERMISSIONS.TRANSACTION_EDIT.key,
          delete: PERMISSIONS.TRANSACTION_DELETE.key
        }
      },
      {
        label: 'Xuất báo cáo Thu tiền nước',
        key: 'billing-report',
        icon: <div><div className="dot-icon"></div></div>,
      }
    ]
  },
  {
    label: 'Chăm sóc khách hàng',
    icon: <img className="mr-4 menu-icon" alt='' width={ICON_WIDTH} height={ICON_WIDTH} src='/images/layout/sidebar/headset-solid.svg' />,
    key: 'customer-support',
    children: [
      {
        label: 'Yêu cầu khách hàng',
        key: 'request',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.USERREQUEST_VIEW.key,
          add: PERMISSIONS.USERREQUEST_ADD.key,
          edit: PERMISSIONS.USERREQUEST_EDIT.key,
          delete: PERMISSIONS.USERREQUEST_DELETE.key
        }
      },
      {
        label: 'Gửi thông báo',
        key: 'send-notification',
        icon: <div><div className="dot-icon"></div></div>,
      },
      {
        label: 'Lịch ngưng cấp nước',
        key: 'suspension',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.WATERSUPPLYSUSPENSION_VIEW.key,
          add: PERMISSIONS.WATERSUPPLYSUSPENSION_ADD.key,
          edit: PERMISSIONS.WATERSUPPLYSUSPENSION_EDIT.key,
          delete: PERMISSIONS.WATERSUPPLYSUSPENSION_DELETE.key
        }
      },
      {
        label: 'Chất lượng nước',
        key: 'sample-test',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.SAMPLETEST_VIEW.key,
          add: PERMISSIONS.SAMPLETEST_ADD.key,
          edit: PERMISSIONS.SAMPLETEST_EDIT.key,
          delete: PERMISSIONS.SAMPLETEST_DELETE.key
        }
      },
      {
        label: 'Điểm thanh toán',
        key: 'payment-point',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.PAYMENTPOINT_VIEW.key,
          add: PERMISSIONS.PAYMENTPOINT_ADD.key,
          edit: PERMISSIONS.PAYMENTPOINT_EDIT.key,
          delete: PERMISSIONS.PAYMENTPOINT_DELETE.key
        }
      }
    ]
  },
  {
    label: 'Quản trị Danh mục',
    key: 'category',
    icon: <img className="mr-4 menu-icon" alt='' width={ICON_WIDTH} height={ICON_WIDTH} src='/images/layout/sidebar/rectangle-list-solid.svg' />,
    children: [
      {
        label: 'Danh mục Khu vực',
        key: 'toll-area',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.TOLLAREA_VIEW.key,
          add: PERMISSIONS.TOLLAREA_ADD.key,
          edit: PERMISSIONS.TOLLAREA_EDIT.key,
          delete: PERMISSIONS.TOLLAREA_DELETE.key
        }
      },
      {
        label: 'Danh mục Loại hình đơn vị',
        key: 'unit-type',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.UNITTYPE_VIEW.key,
          add: PERMISSIONS.UNITTYPE_ADD.key,
          edit: PERMISSIONS.UNITTYPE_EDIT.key,
          delete: PERMISSIONS.UNITTYPE_DELETE.key
        }
      },
      {
        label: 'Danh mục Bảng giá',
        key: 'fee-ladder',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.FEELADDER_VIEW.key,
          add: PERMISSIONS.FEELADDER_ADD.key,
          edit: PERMISSIONS.FEELADDER_EDIT.key,
          delete: PERMISSIONS.FEELADDER_DELETE.key
        }
      },
      {
        label: 'Danh mục Phòng ban',
        key: 'departments',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.DEPARTMENT_VIEW.key,
          add: PERMISSIONS.DEPARTMENT_ADD.key,
          edit: PERMISSIONS.DEPARTMENT_EDIT.key,
          delete: PERMISSIONS.DEPARTMENT_DELETE.key
        }
      },
    ]
  },
  {
    label: 'Quản trị Hệ thống',
    key: 'admin',
    icon: <img className="mr-4 menu-icon" alt='' width={ICON_WIDTH} height={ICON_WIDTH} src='/images/layout/sidebar/screwdriver-wrench-solid.svg' />,
    children: [
      {
        label: 'Quản lý tài khoản',
        key: 'accounts',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.ACCOUNT_VIEW.key,
          add: PERMISSIONS.ACCOUNT_ADD.key,
          edit: PERMISSIONS.ACCOUNT_EDIT.key,
          delete: PERMISSIONS.ACCOUNT_DELETE.key
        }
      },
      {
        label: 'Nhóm quyền',
        key: 'account-groups',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.ROLE_VIEW.key,
          add: PERMISSIONS.ROLE_ADD.key,
          edit: PERMISSIONS.ROLE_EDIT.key,
          delete: PERMISSIONS.ROLE_DELETE.key
        }
      },
      {
        label: 'Nhật ký hệ thống',
        key: 'logs',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.AUDITLOG_VIEW.key,
          add: PERMISSIONS.AUDITLOG_ADD.key,
          edit: PERMISSIONS.AUDITLOG_EDIT.key,
          delete: PERMISSIONS.AUDITLOG_DELETE.key
        }
      },
      {
        label: 'Ứng dụng (tải app)',
        key: 'apps',
        icon: <div><div className="dot-icon"></div></div>,
        permissions: {
          view: PERMISSIONS.ACCOUNT_VIEW.key
        }
      }
    ]
  }
];
